import { useState } from 'react';
import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/manhua';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [subscribeMsg, setSubscribeMsg] = useState('');

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.currentTarget as HTMLFormElement;
    const formData = new FormData(form);
    const honeypot = (formData.get('phone_alt') as string || '').trim();
    if (honeypot) {
      setSubscribeStatus('success');
      setSubscribeMsg('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }
    setSubscribeStatus('loading');
    try {
      const res = await fetch('http://youplz.com/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const responseText = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch (_) { /* ignore */ }
      if (res.ok && parsed?.code === 'OK') {
        setSubscribeStatus('success');
        setSubscribeMsg('订阅成功！感谢您的关注。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        setSubscribeStatus('error');
        setSubscribeMsg(serverMsg.includes('spam') ? '订阅失败，请稍后再试。' : (serverMsg || '订阅失败，请稍后再试。'));
      }
    } catch (_) {
      setSubscribeStatus('error');
      setSubscribeMsg('网络错误，请稍后重试。');
    }
  };

  return (
    <footer className="bg-foreground-950 rounded-2xl mx-4 md:mx-6 mb-6 mt-10">
      <div className="px-6 md:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div className="md:col-span-1">
            <h3 className="text-2xl font-light text-background-50 font-heading mb-4">订阅更新</h3>
            <p className="text-sm text-foreground-300 leading-relaxed mb-6">
              订阅我们的邮件通知，第一时间获取最新漫画更新和独家推荐。
            </p>
            <form onSubmit={handleSubscribe} id="footer-subscribe" className="relative">
              <div className="honeypot-wrapper">
                <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="输入您的邮箱"
                required
                className="w-full bg-transparent border-b border-foreground-600 text-background-50 text-sm py-2 px-0 placeholder-foreground-500 outline-none focus:border-primary-500 transition-colors"
              />
              <button
                type="submit"
                disabled={subscribeStatus === 'loading'}
                className="mt-4 inline-flex items-center gap-2 px-6 py-2 bg-background-50 text-foreground-950 text-sm font-medium rounded-full hover:bg-background-100 transition-colors whitespace-nowrap disabled:opacity-50 cursor-pointer"
              >
                {subscribeStatus === 'loading' ? '提交中...' : '立即订阅'}
                <i className="ri-arrow-right-line text-xs"></i>
              </button>
              {subscribeStatus !== 'idle' && (
                <p className={`mt-2 text-xs ${subscribeStatus === 'success' ? 'text-accent-400' : 'text-red-400'}`}>
                  {subscribeMsg}
                </p>
              )}
            </form>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-label">快速导航</h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline decoration-foreground-600 underline-offset-4 whitespace-nowrap">首页</Link>
              <Link to="/category/love" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline decoration-foreground-600 underline-offset-4 whitespace-nowrap">分类浏览</Link>
              <Link to="/about" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline decoration-foreground-600 underline-offset-4 whitespace-nowrap">关于我们</Link>
              <a href="#latest" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline decoration-foreground-600 underline-offset-4 whitespace-nowrap">最新更新</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-label">联系我们</h4>
            <p className="text-sm text-foreground-300 mb-1">{siteInfo.phone}</p>
            <p className="text-sm text-foreground-300 mb-6">{siteInfo.email}</p>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-label">公司地址</h4>
            <p className="text-sm text-foreground-300 leading-relaxed">{siteInfo.address}</p>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800 px-6 md:px-12 py-5">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-4">
            <a href={siteInfo.socialLinks.weibo} target="_blank" rel="nofollow noopener" className="text-sm text-foreground-400 hover:text-background-50 transition-colors underline decoration-foreground-600 underline-offset-4 whitespace-nowrap">微博</a>
            <span className="text-sm text-foreground-400 whitespace-nowrap">微信：{siteInfo.socialLinks.wechat}</span>
          </div>
          <p className="text-xs text-foreground-500 text-center whitespace-nowrap">
            &copy; {new Date().getFullYear()} 韩漫网 hanmanwang.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-foreground-400 hover:text-background-50 transition-colors underline decoration-foreground-600 underline-offset-4 whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-sm text-foreground-400 hover:text-background-50 transition-colors underline decoration-foreground-600 underline-offset-4 whitespace-nowrap">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}